import styled from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
    display: flex; 
    margin-top: 50px; 
    margin-bottom: 40px; 
    width: 70%; 
    justify-content: space-between;
`;

export default Wrapper(template)
